module.exports = __webpack_public_path__ + "ce210c0a253e73664bef35e77a6f05a9.png";